import { render } from "./MessagesView.vue?vue&type=template&id=e35a93ea&scoped=true"
import script from "./MessagesView.vue?vue&type=script&lang=js"
export * from "./MessagesView.vue?vue&type=script&lang=js"

import "./MessagesView.vue?vue&type=style&index=0&id=e35a93ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e35a93ea"]])

export default __exports__